// US regular trading session (09:30-16:00 ET), defined in ET regardless of the chart's
// display timezone. Shared by the reference-line indicators (open / previous close /
// previous-day high-low) so pre-market and after-hours bars never drive those levels.

const MARKET_TZ = 'America/New_York'
const RTH_OPEN_MIN = 9 * 60 + 30 // 09:30 ET
const RTH_CLOSE_MIN = 16 * 60 // 16:00 ET

const dtfCache = new Map<string, Intl.DateTimeFormat>()

/** Minutes-since-midnight of a timestamp in ET. */
export function etMinutesOfDay(timestamp: number): number {
  let dtf = dtfCache.get(MARKET_TZ)
  if (!dtf) {
    dtf = new Intl.DateTimeFormat('en-US', {
      timeZone: MARKET_TZ,
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    })
    dtfCache.set(MARKET_TZ, dtf)
  }
  const parts = dtf.formatToParts(new Date(timestamp))
  const h = Number(parts.find((p) => p.type === 'hour')?.value ?? '0')
  const m = Number(parts.find((p) => p.type === 'minute')?.value ?? '0')
  return h * 60 + m
}

/** True if the timestamp falls within the regular US session (09:30-16:00 ET). */
export function isRegularSession(timestamp: number): boolean {
  const min = etMinutesOfDay(timestamp)
  return min >= RTH_OPEN_MIN && min < RTH_CLOSE_MIN
}
